const languages = require('./languages');

module.exports = {
  title: "SciChess",
  menu: [
    { label: 'learn', slug: "/learn" },
    { label: 'teach', slug: "/teach" },
    { label: 'about', slug: "/about" },
    { label: 'helpUs', slug: "/help-us" },
    { label: 'software', slug: "/softwares" },
    { label: 'methods', slug: "/methods" }
  ],
  languages
}


// WEBPACK FOOTER //
// ./src/data/siteMetaData.js